
import { defineComponent } from "vue";

/** Shown in place of a panel section the account is not allowed to load (403). */
export default defineComponent({
  name: "PanelNoAccess",
  methods: {
    goBack() {
      this.$router.push({ path: "/panel", hash: "#dashboard" });
    },
  },
});
